  // document.addEventListener("DOMContentLoaded", function () {
  //   if (window.innerWidth <= 768) { // Mobile view breakpoint
  //     const section = document.getElementById('shopify-section-template--17137488691315__details');
  //     const productInfo = document.querySelector('.product-info__block');

  //     if (section && productInfo) {
  //       productInfo.insertAdjacentElement('afterend', section);
  //     }
  //   }
  // });


  document.addEventListener("DOMContentLoaded", function () {
    if (window.innerWidth <= 768) {
      const sectionToMove = document.getElementById('shopify-section-template--17279746965619__details');
      const productForm = document.querySelector('.product-info__block product-form');

      if (sectionToMove && productForm) {
        productForm.insertAdjacentElement('afterend', sectionToMove);
      }
    }
  });